// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"752":"ac3ff69e","799":"cff3f99a"}[chunkId] + ".css";
};